<template>
    <div class="flex flex-col gap-4 text-center items-center text-[#385660]" >
        {{ title }}
        <div class="border rounded-xl border-black w-33 h-20 flex items-center justify-center text-2xl text-[#385660] hover:bg-[#25B0D725] duration-500 hover:scale-105 active:scale-100" >
            {{ content }}
        </div>
    </div>
</template>

<script setup >

    const props = defineProps({
        title: String,
        content: Number,
    })
</script>